/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sleek_Vivid_Parrot_HuntInputs */

const fr_sleek_vivid_parrot_hunt = /** @type {(inputs: Sleek_Vivid_Parrot_HuntInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evénements liés`)
};

/**

* @param {Sleek_Vivid_Parrot_HuntInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sleek_vivid_parrot_hunt = /** @type {((inputs?: Sleek_Vivid_Parrot_HuntInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sleek_Vivid_Parrot_HuntInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sleek_vivid_parrot_hunt(inputs)
});